import { FORM_LOCALES as RAW_FORM_LOCALES } from "./locales";
import { LOCALE_OVERRIDES } from "./locales-overrides";

export * from "./types";
export { FORMS, type FormId } from "./forms";
export { HINT_IMAGES } from "./hint-images";
export { FAQ_LIST, type FaqItem } from "./faq";

// Merge per-language: overrides take precedence over the auto-generated
// dump. See ./locales-overrides.ts for the rationale.
const merged: Record<string, Record<string, string>> = {};
for (const lang of Object.keys(RAW_FORM_LOCALES)) {
	merged[lang] = {
		...RAW_FORM_LOCALES[lang],
		...(LOCALE_OVERRIDES[lang] || {}),
	};
}

export const FORM_LOCALES: Record<string, Record<string, string>> = merged;
